import { useEffect } from 'react'
import { useLocation } from 'react-router'

/**
 * Scroll to the element a `#fragment` names, on every in-app navigation.
 *
 * The browser does this on a full load and React Router does not on a push, so
 * `/settings/connections#sender` from the Connections list — or `#health` on
 * the outreach overview — landed at the top of the page and left the reader to
 * find the card (walkthrough 2026-09-12). Deferred one frame so the route's own
 * query has had a render to mount the target; a target that mounts later than
 * that is reached on the next hash change.
 *
 * A hook rather than an effect inside `AppShell`, since the settings screen
 * left the shell (2026-09-16) and both frames need the same behaviour.
 */
export function useHashScroll(): void {
  const location = useLocation()
  useEffect(() => {
    if (!location.hash) return
    const id = location.hash.slice(1)
    const frame = window.requestAnimationFrame(() => {
      document.getElementById(id)?.scrollIntoView({ block: 'start' })
    })
    return () => {
      window.cancelAnimationFrame(frame)
    }
  }, [location.hash, location.pathname])
}
